export default {
  occo: 'GTM-T92MVP5'
};
